import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "@master/core/dist/core";
import { config } from "@config/config";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class LanguageService extends BaseService {
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService);
  }


  /**
   * Evaluate condition like sequelize sintaxis
   * @param data 
   * @param conditions 
   * @returns 
   */
  getLanguages(): Promise<any> {
    // tslint:disable-next-line:max-line-length
    const url = this.getUrl() + "/languages";
    return this.http.get(url).toPromise();
  }
}
